import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const services = [
  {
    icon: 'ri-palette-line',
    title: 'Design graphique',
    description:
      'Création de visuels, logos et supports de communication clairs et percutants, adaptés à votre identité.',
  },
  {
    icon: 'ri-eye-line',
    title: 'Design visuel',
    description:
      'Développement d\'identités visuelles simples et cohérentes qui reflètent vos valeurs et votre positionnement.',
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'Conception créative',
    description:
      'Création de concepts visuels sur mesure pour vos projets professionnels, du brief à la livraison finale.',
  },
];

export default function Home() {
  return (
    <main style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <Navbar />

      {/* ── Hero ── */}
      <section className="min-h-screen bg-white flex flex-col justify-center pt-20 pb-0">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 w-full">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-0 items-center py-16 lg:py-24">

            {/* Left: Big Title */}
            <div className="lg:col-span-3">
              <span className="inline-block text-xs font-medium tracking-widest text-[#6B6B6B] uppercase mb-6 border-b border-[#6B6B6B] pb-1">
                Studio de design — Bordeaux
              </span>
              <h1 className="text-5xl sm:text-6xl lg:text-8xl font-bold text-[#0A0A0A] leading-[0.95] tracking-tight">
                Studio<br />
                <em style={{ fontFamily: "'Playfair Display', serif" }} className="not-italic text-[#0A0A0A]">de</em><br />
                design
              </h1>
            </div>

            {/* Right: Description + CTA */}
            <div className="lg:col-span-2 flex flex-col justify-center lg:pt-10">
              <p className="text-[#6B6B6B] text-base lg:text-lg leading-relaxed mb-8 max-w-sm">
                HASPICA propose des services de design adaptés aux besoins des entreprises et des particuliers. L'objectif est de créer des visuels clairs, modernes et efficaces.
              </p>
              <div className="flex items-center gap-4 flex-wrap">
                <Link
                  to="/contact"
                  className="px-7 py-3.5 bg-[#0A0A0A] text-white text-sm font-medium rounded-md whitespace-nowrap cursor-pointer hover:bg-[#2A2A2A] transition-colors duration-200"
                >
                  Discuter de votre projet
                </Link>
                <Link
                  to="/a-propos"
                  className="px-7 py-3.5 border border-[#0A0A0A] text-[#0A0A0A] text-sm font-medium rounded-md whitespace-nowrap cursor-pointer hover:bg-[#F5F5F5] transition-colors duration-200"
                >
                  En savoir plus
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Full-width Hero Image */}
        <div className="w-full h-[45vh] lg:h-[55vh] overflow-hidden">
          <img
            src="https://public.readdy.ai/ai/img_res/7f88ae20de1b1a4e93f296121eaf707f.jpg"
            alt="Studio de design HASPICA à Bordeaux"
            title="Studio de design graphique et visuel HASPICA"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </section>

      {/* ── Services ── */}
      <section className="bg-[#F7F6F4] py-24" id="services">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="mb-14">
            <span className="text-xs font-medium tracking-widest text-[#6B6B6B] uppercase">Nos expertises</span>
            <h2 className="text-3xl lg:text-4xl font-bold text-[#0A0A0A] mt-2">Services</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {services.map((service) => (
              <article
                key={service.title}
                className="bg-white rounded-lg p-8 hover:bg-[#0A0A0A] group transition-colors duration-300 cursor-default"
              >
                <div className="w-10 h-10 flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-2xl text-[#0A0A0A] group-hover:text-white transition-colors duration-300`} />
                </div>
                <h3 className="text-lg font-semibold text-[#0A0A0A] group-hover:text-white mb-3 transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-sm text-[#6B6B6B] group-hover:text-gray-300 leading-relaxed transition-colors duration-300">
                  {service.description}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ── Approche ── */}
      <section className="py-0 overflow-hidden" id="approche">
        <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[500px]">
          {/* Image */}
          <div className="relative h-72 lg:h-auto overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=minimalist%20graphic%20design%20process%2C%20clean%20white%20desk%20with%20sketchbooks%20pencils%20and%20grid%20paper%2C%20designer%20working%20on%20visual%20identity%2C%20soft%20natural%20light%2C%20elegant%20composition%2C%20black%20and%20white%20with%20warm%20neutral%20tones%2C%20professional%20creative%20workspace%2C%20design%20tools%20and%20color%20swatches%20laid%20flat&width=720&height=600&seq=approach001&orientation=portrait"
              alt="Approche design HASPICA"
              title="Méthode de travail studio HASPICA Bordeaux"
              className="w-full h-full object-cover object-top"
            />
          </div>
          {/* Text */}
          <div className="bg-white flex flex-col justify-center px-10 lg:px-16 py-16">
            <span className="text-xs font-medium tracking-widest text-[#6B6B6B] uppercase mb-4">Approche</span>
            <h2 className="text-3xl lg:text-4xl font-bold text-[#0A0A0A] leading-tight mb-6">
              Chaque projet<br />
              <em style={{ fontFamily: "'Playfair Display', serif" }} className="not-italic text-[#0A0A0A]">mérite attention</em>
            </h2>
            <p className="text-[#6B6B6B] text-base leading-relaxed mb-8 max-w-sm">
              Chaque projet est réalisé avec soin afin de proposer des solutions simples, efficaces et parfaitement adaptées aux besoins du client. Clarté, cohérence et qualité d'exécution guident chaque étape.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-[#0A0A0A] text-white text-sm font-medium rounded-full whitespace-nowrap cursor-pointer hover:bg-[#2A2A2A] transition-colors duration-200 self-start"
            >
              Démarrer un projet
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm" />
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="bg-[#0A0A0A] py-24 text-center">
        <div className="max-w-3xl mx-auto px-6 lg:px-12">
          <span className="text-xs font-medium tracking-widest text-gray-500 uppercase">Contact</span>
          <h2 className="text-3xl lg:text-5xl font-bold text-white mt-4 mb-6 leading-tight">
            Contactez-nous pour<br />
            <em style={{ fontFamily: "'Playfair Display', serif" }} className="italic text-gray-300">discuter de votre projet</em>
          </h2>
          <p className="text-gray-400 text-base mb-10 leading-relaxed">
            Que vous soyez une entreprise ou un particulier, HASPICA vous accompagne dans la création de vos visuels à Bordeaux et partout en France.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-9 py-4 bg-white text-[#0A0A0A] text-sm font-semibold rounded-full whitespace-nowrap cursor-pointer hover:bg-gray-100 transition-colors duration-200"
          >
            Nous contacter
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm" />
            </div>
          </Link>
        </div>
      </section>

      <Footer />
    </main>
  );
}
